import React from 'react'

import { FeatureListItem } from './FeatureListItem'

interface FeatureListProps extends Omit<React.HTMLAttributes<HTMLDListElement>, 'className'> {
  children: React.ReactNode;
}

export function FeatureList ({ children, ...props }: FeatureListProps) {
  return <dl {...props} className='space-y-2'>{children}</dl>
}

FeatureList.Item = FeatureListItem
